import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import {PropertyClearUIListenerParams} from '#/DefaultViewExtensionInterfaces';

export default class RADLdapConnectionUIListener extends UIListener {

    constructor() {
        super();

        this.createChain(
            this.createPropertyClearUIListener(),
        );
    }

    private createPropertyClearUIListener() {
        const params: PropertyClearUIListenerParams = {
            rules: [
                {
                    propertiesToWatch: ['Server'],
                    propertiesToClear: ['AdminUserPassword']
                }
            ]
        };
        return {
            uiListener: 'PropertyClearUIListener',
            params: params
        };
    }
}

ComponentManager.setUIListener('RADLdapConnectionUIListener', RADLdapConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.RADLdapConnectionUIListener', RADLdapConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');